module.exports = __webpack_public_path__ + "img/tent.4f8d54e3.svg";